import { grey } from './colors';
const white = '#FFFFFF';
const black = grey[900];

/**
 * Palette
 *
 * Demos:
 *
 * - [App bar](https://ui-packages.isbuildingluma.com/ui-core/customization/color/)
 *
 * Styles:
 *
 * - [Proto](https://www.figma.com/file/N3gFGSM48EkhCahScVFcoK/Luma-Patient-Design-System?node-id=871%3A4364&mode=dev)
 */
const palette = {
  common: {
    white,
    black
  },
  grey,
  background: {
    default: grey[100],
    paper: white
  },
  text: {
    primary: black,
    secondary: grey[700],
    disabled: grey[500]
  }
};
export default palette;